import { render, staticRenderFns } from "./ProjectCreate.vue?vue&type=template&id=8f98058a&scoped=true"
import script from "./ProjectCreate.vue?vue&type=script&lang=js"
export * from "./ProjectCreate.vue?vue&type=script&lang=js"
import style0 from "./ProjectCreate.vue?vue&type=style&index=0&id=8f98058a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f98058a",
  null
  
)

export default component.exports